import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__customer-edit-confirm-modal';
export default class CustomerEditConfirmModal {
    static $element;
    static $targetInput;
    static $targetForm;
    static init() {
        this.$element = $(ELEMENT_SELECTOR);
        this.$targetInput = $(this.$element.data('target-input'));
        this.$targetForm = this.$targetInput.closest('form');
        this.show();
    }
    static show() {
        this.$element
            .modal({
            autofocus: false,
            closable: false,
            onApprove: () => {
                this.$targetInput.val(1);
                this.$targetForm.trigger('submit').addClass('loading');
            },
            onDeny: () => {
                this.$targetInput.remove();
            },
        })
            .modal('show');
    }
}
